import { NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RRSSLinks } from '../../constants/rrss-links';

@Component({
  selector: 'app-rrss-links',
  standalone: true,
  imports: [NgFor],
  templateUrl: './rrss-links.component.html'
})
export class rrssLinksComponent implements OnInit {

  @Input()
  public cssClass!: string;

  @Input()
  public type!: string;

  public links: any[] = [];

  constructor() {
  }

  ngOnInit(): void {
    if (this.type) {
      this.links = this._filterList(this.type);
    } else {
      this.links = RRSSLinks;
    }
  }

  public openLink(link: string) {
    window.open(link);
  }

  private _filterList(type: string): any[] {
    return RRSSLinks.filter(link => link.type.includes(type));
  }
}
